import instance from "../globals/axios";

export const getDehaatJwt = async () => {
  try {
    const res = await instance.get("/externalpartners/get-dehaat-payload/");
    return res?.data?.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
